module.exports = __webpack_public_path__ + "static/img/silver.ec5c4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/silver.png
// module id = 611U
// module chunks = 35